/**
 * /packs — unified pricing page (Hobby / Pro / Enterprise org via contact).
 * Accessible to all users (signed-in and anonymous).
 */

import { PricingScreen } from '../src/packs/components/PricingScreen/PricingScreen'

export default function PacksRoute() {
  return <PricingScreen />
}
